var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11457_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.32 28.64C18.1179 28.64 21.7602 27.1313 24.4458 24.4458C27.1313 21.7602 28.64 18.1179 28.64 14.32C28.64 10.5221 27.1313 6.87975 24.4458 4.19423C21.7602 1.50871 18.1179 0 14.32 0C10.5221 0 6.87975 1.50871 4.19423 4.19423C1.50871 6.87975 0 10.5221 0 14.32C0 18.1179 1.50871 21.7602 4.19423 24.4458C6.87975 27.1313 10.5221 28.64 14.32 28.64ZM20.6409 11.6909L13.4809 18.8509C12.9551 19.3767 12.1049 19.3767 11.5847 18.8509L8.00466 15.2709C7.47884 14.7451 7.47884 13.8949 8.00466 13.3747C8.53047 12.8544 9.38072 12.8488 9.90094 13.3747L12.53 16.0037L18.7391 9.78906C19.2649 9.26325 20.1151 9.26325 20.6353 9.78906C21.1556 10.3149 21.1612 11.1651 20.6353 11.6853L20.6409 11.6909Z",
    fill: "#91BF82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11457_7865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.64,
    height: 28.64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/Completed.834cb4f55d8d48ca7cb730b4768fd838.svg";
export { ForwardRef as ReactComponent };